import PropTypes from 'prop-types'
import React from 'react'
import { createUseStyles } from 'react-jss'

import { Breadcrumb } from '../../components'
import CompanyDetailsWrapper from '../../components/CompanyDetails/wrapper'
import FooterWrapper from '../../components/Footer/wrapper'
import HeaderWrapper from '../../components/Header/wrapper'
import withMemo from '../../decorators/WithMemo'
import usePWAInstallPrompt from '../../hooks/usePWAInstallPrompt'

import styles from './styles'


const useStyles = createUseStyles(styles)

function CompanyTemplate(props) {
  usePWAInstallPrompt()

  const { data = null, breadcrumb = [] } = props
  const classes = useStyles(props)

  return (
    <div className={classes.container}>
      <HeaderWrapper />
      <Breadcrumb
        entries={breadcrumb}
        className={classes.breadcrumb}
      />
      {data && (
        <CompanyDetailsWrapper
          {...data}
        />
      )}
      <FooterWrapper />
    </div>
  )
}

CompanyTemplate.styles = styles

CompanyTemplate.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string),
  data: PropTypes.shape(CompanyDetailsWrapper.propTypes),
  // eslint-disable-next-line
  breadcrumb: PropTypes.array,
}

export default withMemo()(CompanyTemplate)
